{
  "name": "ersagent-frontend",
  "version": "1.8.0",
  "engines": {
    "node": ">=22.12.0 <24.0.0"
  },
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:mock": "ng serve --configuration mock",
    "start:mock:server": "concurrently \"node mock-api/app.js\" \"npm run start:mock\"",
    "build": "ng build",
    "watch": "ng build --watch --configuration dev",
    "test": "jest --no-cache",
    "lint": "eslint .",
    "lint:fix": "eslint . --fix",
    "version": "echo $npm_package_version",
    "deps:check": "bash scripts/check-outdated.sh"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.2.0",
    "@angular/cdk": "^21.2.0",
    "@angular/common": "^21.2.0",
    "@angular/compiler": "^21.2.0",
    "@angular/core": "^21.2.0",
    "@angular/forms": "^21.2.0",
    "@angular/material": "^21.2.0",
    "@angular/platform-browser": "^21.2.0",
    "@angular/platform-browser-dynamic": "^21.2.0",
    "@angular/router": "^21.2.0",
    "@ngrx/effects": "^21.0.1",
    "@ngrx/operators": "^21.0.1",
    "@ngrx/signals": "^21.0.1",
    "@ngrx/store": "^21.0.1",
    "@okta/okta-angular": "^7.0.0",
    "@okta/okta-auth-js": "^7.14.1",
    "lib-automotive-call-cdm": "^1.43.0",
    "luxon": "^3.7.2",
    "maplibre-gl": "^5.1.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^13.0.0"
  },
  "devDependencies": {
    "@angular/build": "^21.2.0",
    "@angular/cli": "~21.2.0",
    "@angular/compiler-cli": "^21.2.0",
    "@ngrx/eslint-plugin": "^21.0.1",
    "@types/jest": "^30.0.0",
    "@types/luxon": "^3.7.1",
    "@types/node": "^22.19.13",
    "@typescript-eslint/eslint-plugin": "^8.56.1",
    "@typescript-eslint/parser": "^8.56.1",
    "concurrently": "^9.2.1",
    "connect-api-mocker": "^1.11.0",
    "cors": "^2.8.6",
    "eslint": "^9.39.3",
    "express": "^5.2.1",
    "jest": "^30.2.0",
    "jest-environment-jsdom": "^30.2.0",
    "jest-preset-angular": "^16.1.1",
    "ng-mocks": "^14.15.1",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.56.1"
  }
}
